import getSearch from "storefront/GrailedAPI/v1/Searches/getSearch";
import useData from "storefront/hooks/data/useData";
import { completed } from "storefront/lib/Resource";
import { Search } from "storefront/Search";

const useSearch = (uuid: string | null) => {
  const params = uuid ? { feedId: uuid } : { feedId: "" };

  const shouldFetch = !!uuid;

  const resource = useData(getSearch, { args: [params], shouldFetch });

  if (resource.type === "Completed") {
    return completed<Search>(resource.value.data);
  }
  return resource;
};
export default useSearch;
